const config = {
  dev: {
    cognito: {
      USER_POOL_ID:
        process.env.REACT_APP_COGNITO_POOL_ID || "us-east-2_yD5dcBiV7",
      APP_CLIENT_ID:
        process.env.REACT_APP_COGNITO_CLIENT_ID || "e0p5q7ef4b2jgirpja657hkdu",
    },
    api: {
      USER: "https://api.dev.thinkhomewise.com/partner/user",
      LOGO_UPLOAD: "https://api.dev.thinkhomewise.com/partner/logo",
      PARTNER: "https://api.dev.thinkhomewise.com/partner/brand",
    },
    google: {
      CAPTCHA: "6Lf5QtQUAAAAABY8kRzWmZcg1s8lGiceF_rr58kg",
      MAPS: "AIzaSyDyWGrkTmlAda3p3JXCGTlkUZSsQvVO36k",
      GTM_ID: "GTM-PMSKZCR",
      GTM_AUTH: "U-43HtWacFbk_8tJlDsk7w",
      GTM_PREV: "env-3",
    },
  },
  staging: {
    cognito: {
      USER_POOL_ID: process.env.REACT_APP_COGNITO_POOL_ID,
      APP_CLIENT_ID: process.env.REACT_APP_COGNITO_CLIENT_ID,
    },
    api: {
      USER: "https://api.staging.thinkhomewise.com/partner/user",
      LOGO_UPLOAD: "https://api.staging.thinkhomewise.com/partner/logo",
      PARTNER: "https://api.staging.thinkhomewise.com/partner/brand",
    },
    google: {
      CAPTCHA: "6Lf5QtQUAAAAABY8kRzWmZcg1s8lGiceF_rr58kg",
      MAPS: "AIzaSyDMfk26oa5PX6ryIuSQzzed3-fy7m1EAgY",
      GTM_ID: "GTM-PMSKZCR",
      GTM_AUTH: "HzMAsQ784A9WgOmUq1xmYw",
      GTM_PREV: "env-4",
    },
  },
  prod: {
    cognito: {
      USER_POOL_ID: process.env.REACT_APP_COGNITO_POOL_ID,
      APP_CLIENT_ID: process.env.REACT_APP_COGNITO_CLIENT_ID,
    },
    api: {
      USER: "https://api.thinkhomewise.com/partner/user",
      LOGO_UPLOAD: "https://api.thinkhomewise.com/partner/logo",
      PARTNER: "https://api.thinkhomewise.com/partner/brand",
    },
    google: {
      CAPTCHA: "6Lf5QtQUAAAAABY8kRzWmZcg1s8lGiceF_rr58kg",
      MAPS: "AIzaSyD7y0a8KlNHffynHjYQfrVTqrYAx92iVjA",
      GTM_ID: "GTM-PMSKZCR",
      GTM_AUTH: "B4IhV5jLhnkKbFSwG0ulPQ",
      GTM_PREV: "env-1",
    },
  },
};

export default {
  // Add common config values here
  ...config[process.env.REACT_APP_STAGE],
};
